export const I18N_EVENTS = ['loaded', 'languageChanged'] as const;

// Inline translation edits mutate the i18next resource store directly via addResource(...).
export const I18N_STORE_EVENTS = ['added', 'removed'] as const;
